var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/node-libs-browser/node_modules/isarray/index.js
// module id = 558
// module chunks = 0 1